import api from '../config/axiosConfig';
import {assertApiSuccess} from '../utils/apiResponseUtils';

const checked = response => { assertApiSuccess(response); return response.data.data; };
export const driverSupport = {
  list: async page => checked(await api.get('/driver/support/cases', {params: {page, size: 10}})),
  get: async id => checked(await api.get('/driver/support/cases/' + encodeURIComponent(id))),
  create: async (body, key) => checked(await api.post('/driver/support/cases', body, {headers: {'Idempotency-Key': key}})),
  message: async (id, body, key) => checked(await api.post('/driver/support/cases/' + encodeURIComponent(id) + '/messages', body, {headers: {'Idempotency-Key': key}})),
};

export const customerSupport = {
  list: async page => checked(await api.get('/account/support/cases', {params: {page, size: 10}})),
  get: async id => checked(await api.get('/account/support/cases/' + encodeURIComponent(id))),
  create: async (body, key) => checked(await api.post('/account/support/cases', body, {headers: {'Idempotency-Key': key}})),
  message: async (id, body, key) => checked(await api.post('/account/support/cases/' + encodeURIComponent(id) + '/messages', body, {headers: {'Idempotency-Key': key}})),
};
